/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BorrowerContractualizationResponse,
  ContractualizationResponseDto,
  CreateDevisOptim400Response,
  CreateDevisOptim404Response,
  CreateDevisOptim500Response,
  CreateMandateSignatureCommand,
  CreateQuoteCommandDto,
  CreateQuoteResponseDto,
  DemanderValidationCommand,
  ErrorResponse,
  EtatValidationDevis,
  GetAdminQuoteListResponseDto,
  GetFacetsResponse,
  GetGenericListCommandDto,
  GetMandateByQuoteId404Response,
  GetQuoteFilterResponseDto,
  GetQuoteListResponseDto,
  MandateSignatoryDto,
  MncapSendSmsCodeCommand,
  MncapSendSmsCodeResponseDto,
  MncapValidateTokenResponseDto,
  MncapVerifySmsCodeCommand,
  MncapVerifySmsCodeResponseDto,
  OperationResponse,
  QuoteMandateDto,
  SendContractCommandDto,
  SendContractResponseDto,
  UpdateQuoteMandateDto,
} from '../models/index';
import {
    BorrowerContractualizationResponseFromJSON,
    BorrowerContractualizationResponseToJSON,
    ContractualizationResponseDtoFromJSON,
    ContractualizationResponseDtoToJSON,
    CreateDevisOptim400ResponseFromJSON,
    CreateDevisOptim400ResponseToJSON,
    CreateDevisOptim404ResponseFromJSON,
    CreateDevisOptim404ResponseToJSON,
    CreateDevisOptim500ResponseFromJSON,
    CreateDevisOptim500ResponseToJSON,
    CreateMandateSignatureCommandFromJSON,
    CreateMandateSignatureCommandToJSON,
    CreateQuoteCommandDtoFromJSON,
    CreateQuoteCommandDtoToJSON,
    CreateQuoteResponseDtoFromJSON,
    CreateQuoteResponseDtoToJSON,
    DemanderValidationCommandFromJSON,
    DemanderValidationCommandToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    EtatValidationDevisFromJSON,
    EtatValidationDevisToJSON,
    GetAdminQuoteListResponseDtoFromJSON,
    GetAdminQuoteListResponseDtoToJSON,
    GetFacetsResponseFromJSON,
    GetFacetsResponseToJSON,
    GetGenericListCommandDtoFromJSON,
    GetGenericListCommandDtoToJSON,
    GetMandateByQuoteId404ResponseFromJSON,
    GetMandateByQuoteId404ResponseToJSON,
    GetQuoteFilterResponseDtoFromJSON,
    GetQuoteFilterResponseDtoToJSON,
    GetQuoteListResponseDtoFromJSON,
    GetQuoteListResponseDtoToJSON,
    MandateSignatoryDtoFromJSON,
    MandateSignatoryDtoToJSON,
    MncapSendSmsCodeCommandFromJSON,
    MncapSendSmsCodeCommandToJSON,
    MncapSendSmsCodeResponseDtoFromJSON,
    MncapSendSmsCodeResponseDtoToJSON,
    MncapValidateTokenResponseDtoFromJSON,
    MncapValidateTokenResponseDtoToJSON,
    MncapVerifySmsCodeCommandFromJSON,
    MncapVerifySmsCodeCommandToJSON,
    MncapVerifySmsCodeResponseDtoFromJSON,
    MncapVerifySmsCodeResponseDtoToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    QuoteMandateDtoFromJSON,
    QuoteMandateDtoToJSON,
    SendContractCommandDtoFromJSON,
    SendContractCommandDtoToJSON,
    SendContractResponseDtoFromJSON,
    SendContractResponseDtoToJSON,
    UpdateQuoteMandateDtoFromJSON,
    UpdateQuoteMandateDtoToJSON,
} from '../models/index';

export interface AddScheduleToMandateRequest {
    quoteId: string;
    updateQuoteMandateDto: UpdateQuoteMandateDto;
}

export interface CancelQuoteValidationRequestRequest {
    devisId: string;
}

export interface CreateDevisOptimRequest {
    createQuoteCommandDto: CreateQuoteCommandDto;
}

export interface CreateMandateSignatureRequest {
    quoteId: string;
    createMandateSignatureCommand: CreateMandateSignatureCommand;
}

export interface GetAdminQuoteListFacetsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetAdminQuotesRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetBorrowerContractualizationInfosRequest {
    borrowerId: string;
    quoteId?: string;
}

export interface GetMandateByQuoteIdRequest {
    quoteId: string;
}

export interface GetMandateSignatoryRequest {
    quoteId: string;
}

export interface GetQuoteInformationsRequest {
    devisId: string;
}

export interface GetQuoteListFacetsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetQuoteValidationRequest {
    devisId: string;
}

export interface GetQuotesRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface RequestQuoteValidationRequest {
    devisId: string;
    demanderValidationCommand: DemanderValidationCommand;
}

export interface SendContractRequest {
    sendContractCommandDto: SendContractCommandDto;
}

export interface SendMncapMedicalSmsCodeRequest {
    mncapSendSmsCodeCommand: MncapSendSmsCodeCommand;
}

export interface TriggerMNCAPProcessRequest {
    borrowerId: string;
}

export interface ValidateMncapMedicalTokenRequest {
    token: string;
}

export interface VerifyMncapMedicalSmsCodeRequest {
    mncapVerifySmsCodeCommand: MncapVerifySmsCodeCommand;
}

/**
 * 
 */
export class QuotesApi extends runtime.BaseAPI {

    /**
     * Add Mandate Schedule
     */
    async addScheduleToMandateRaw(requestParameters: AddScheduleToMandateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['quoteId'] == null) {
            throw new runtime.RequiredError(
                'quoteId',
                'Required parameter "quoteId" was null or undefined when calling addScheduleToMandate().'
            );
        }

        if (requestParameters['updateQuoteMandateDto'] == null) {
            throw new runtime.RequiredError(
                'updateQuoteMandateDto',
                'Required parameter "updateQuoteMandateDto" was null or undefined when calling addScheduleToMandate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/devis/{quoteId}/mandat`.replace(`{${"quoteId"}}`, encodeURIComponent(String(requestParameters['quoteId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateQuoteMandateDtoToJSON(requestParameters['updateQuoteMandateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Add Mandate Schedule
     */
    async addScheduleToMandate(requestParameters: AddScheduleToMandateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.addScheduleToMandateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Withdraw the pending validation request of the quote
     */
    async cancelQuoteValidationRequestRaw(requestParameters: CancelQuoteValidationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['devisId'] == null) {
            throw new runtime.RequiredError(
                'devisId',
                'Required parameter "devisId" was null or undefined when calling cancelQuoteValidationRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/devis/{devisId}/validation/demande`.replace(`{${"devisId"}}`, encodeURIComponent(String(requestParameters['devisId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Withdraw the pending validation request of the quote
     */
    async cancelQuoteValidationRequest(requestParameters: CancelQuoteValidationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.cancelQuoteValidationRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new optimized insurance quote based on simulation data and selected parameters
     * Create an optimized insurance quote
     */
    async createDevisOptimRaw(requestParameters: CreateDevisOptimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateQuoteResponseDto>> {
        if (requestParameters['createQuoteCommandDto'] == null) {
            throw new runtime.RequiredError(
                'createQuoteCommandDto',
                'Required parameter "createQuoteCommandDto" was null or undefined when calling createDevisOptim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/devis/create-devis-optim`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateQuoteCommandDtoToJSON(requestParameters['createQuoteCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateQuoteResponseDtoFromJSON(jsonValue));
    }

    /**
     * Creates a new optimized insurance quote based on simulation data and selected parameters
     * Create an optimized insurance quote
     */
    async createDevisOptim(requestParameters: CreateDevisOptimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateQuoteResponseDto> {
        const response = await this.createDevisOptimRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create signature for mandate
     */
    async createMandateSignatureRaw(requestParameters: CreateMandateSignatureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['quoteId'] == null) {
            throw new runtime.RequiredError(
                'quoteId',
                'Required parameter "quoteId" was null or undefined when calling createMandateSignature().'
            );
        }

        if (requestParameters['createMandateSignatureCommand'] == null) {
            throw new runtime.RequiredError(
                'createMandateSignatureCommand',
                'Required parameter "createMandateSignatureCommand" was null or undefined when calling createMandateSignature().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/devis/{quoteId}/mandat/signature`.replace(`{${"quoteId"}}`, encodeURIComponent(String(requestParameters['quoteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMandateSignatureCommandToJSON(requestParameters['createMandateSignatureCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Create signature for mandate
     */
    async createMandateSignature(requestParameters: CreateMandateSignatureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createMandateSignatureRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Facettes de la liste admin des devis, avec les dimensions plateformes et courtiers. Permission BackOffice.AdminDevis.Read (403 sinon). 
     * Get admin quote list facets (BO admin)
     */
    async getAdminQuoteListFacetsRaw(requestParameters: GetAdminQuoteListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFacetsResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getAdminQuoteListFacets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/devis/admin/liste/filtres`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFacetsResponseFromJSON(jsonValue));
    }

    /**
     * Facettes de la liste admin des devis, avec les dimensions plateformes et courtiers. Permission BackOffice.AdminDevis.Read (403 sinon). 
     * Get admin quote list facets (BO admin)
     */
    async getAdminQuoteListFacets(requestParameters: GetAdminQuoteListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFacetsResponse> {
        const response = await this.getAdminQuoteListFacetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Liste admin paginée des devis, toutes plateformes. Items enrichis de brokerId/brokerName et plateformeId/plateformeName. filters.plateformeIds et filters.brokerIds disponibles (brokerIds seul remonte tous les dossiers du courtier, même multi-plateformes). Permission BackOffice.AdminDevis.Read (403 sinon). Remplace l\'usage admin de /api/backoffice/devis/liste. 
     * Get quotes, all plateformes (BO admin)
     */
    async getAdminQuotesRaw(requestParameters: GetAdminQuotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAdminQuoteListResponseDto>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getAdminQuotes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/devis/admin/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAdminQuoteListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Liste admin paginée des devis, toutes plateformes. Items enrichis de brokerId/brokerName et plateformeId/plateformeName. filters.plateformeIds et filters.brokerIds disponibles (brokerIds seul remonte tous les dossiers du courtier, même multi-plateformes). Permission BackOffice.AdminDevis.Read (403 sinon). Remplace l\'usage admin de /api/backoffice/devis/liste. 
     * Get quotes, all plateformes (BO admin)
     */
    async getAdminQuotes(requestParameters: GetAdminQuotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAdminQuoteListResponseDto> {
        const response = await this.getAdminQuotesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve insurance quote information by quote ID
     */
    async getBorrowerContractualizationInfosRaw(requestParameters: GetBorrowerContractualizationInfosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BorrowerContractualizationResponse>> {
        if (requestParameters['borrowerId'] == null) {
            throw new runtime.RequiredError(
                'borrowerId',
                'Required parameter "borrowerId" was null or undefined when calling getBorrowerContractualizationInfos().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['quoteId'] != null) {
            queryParameters['quoteId'] = requestParameters['quoteId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/devis/emprunteurs/{borrowerId}`.replace(`{${"borrowerId"}}`, encodeURIComponent(String(requestParameters['borrowerId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BorrowerContractualizationResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve insurance quote information by quote ID
     */
    async getBorrowerContractualizationInfos(requestParameters: GetBorrowerContractualizationInfosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BorrowerContractualizationResponse> {
        const response = await this.getBorrowerContractualizationInfosRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get mandate information for a specific quote
     */
    async getMandateByQuoteIdRaw(requestParameters: GetMandateByQuoteIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuoteMandateDto>> {
        if (requestParameters['quoteId'] == null) {
            throw new runtime.RequiredError(
                'quoteId',
                'Required parameter "quoteId" was null or undefined when calling getMandateByQuoteId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/devis/{quoteId}/mandat`.replace(`{${"quoteId"}}`, encodeURIComponent(String(requestParameters['quoteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuoteMandateDtoFromJSON(jsonValue));
    }

    /**
     * Get mandate information for a specific quote
     */
    async getMandateByQuoteId(requestParameters: GetMandateByQuoteIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuoteMandateDto> {
        const response = await this.getMandateByQuoteIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the person who will sign the mandate (carried by the mandate, or resolved from the debtor). Null when the quote has no mandate or no eligible signatory.
     * Signatory of the quote\'s SEPA mandate
     */
    async getMandateSignatoryRaw(requestParameters: GetMandateSignatoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MandateSignatoryDto>> {
        if (requestParameters['quoteId'] == null) {
            throw new runtime.RequiredError(
                'quoteId',
                'Required parameter "quoteId" was null or undefined when calling getMandateSignatory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/devis/{quoteId}/mandat/signataire`.replace(`{${"quoteId"}}`, encodeURIComponent(String(requestParameters['quoteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MandateSignatoryDtoFromJSON(jsonValue));
    }

    /**
     * Returns the person who will sign the mandate (carried by the mandate, or resolved from the debtor). Null when the quote has no mandate or no eligible signatory.
     * Signatory of the quote\'s SEPA mandate
     */
    async getMandateSignatory(requestParameters: GetMandateSignatoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MandateSignatoryDto> {
        const response = await this.getMandateSignatoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get quotes filters
     */
    async getQuoteFiltersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetQuoteFilterResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/devis/filters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetQuoteFilterResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get quotes filters
     */
    async getQuoteFilters(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetQuoteFilterResponseDto> {
        const response = await this.getQuoteFiltersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve insurance quote information by quote ID
     */
    async getQuoteInformationsRaw(requestParameters: GetQuoteInformationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContractualizationResponseDto>> {
        if (requestParameters['devisId'] == null) {
            throw new runtime.RequiredError(
                'devisId',
                'Required parameter "devisId" was null or undefined when calling getQuoteInformations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/devis/{devisId}/optim`.replace(`{${"devisId"}}`, encodeURIComponent(String(requestParameters['devisId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContractualizationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve insurance quote information by quote ID
     */
    async getQuoteInformations(requestParameters: GetQuoteInformationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContractualizationResponseDto> {
        const response = await this.getQuoteInformationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Facettes du panneau de filtres de la liste des devis (espace courtier). Envoyer les filtres courants dans le body : les options d\'une dimension sont calculées avec tous les filtres sauf celui de la dimension elle-même. À rappeler à l\'ouverture du panneau et à chaque changement de filtre ou de searchString (debounce ~300 ms) — pas au changement de page. 
     * Get quote list facets (courtier)
     */
    async getQuoteListFacetsRaw(requestParameters: GetQuoteListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFacetsResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getQuoteListFacets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/devis/liste/filtres`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFacetsResponseFromJSON(jsonValue));
    }

    /**
     * Facettes du panneau de filtres de la liste des devis (espace courtier). Envoyer les filtres courants dans le body : les options d\'une dimension sont calculées avec tous les filtres sauf celui de la dimension elle-même. À rappeler à l\'ouverture du panneau et à chaque changement de filtre ou de searchString (debounce ~300 ms) — pas au changement de page. 
     * Get quote list facets (courtier)
     */
    async getQuoteListFacets(requestParameters: GetQuoteListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFacetsResponse> {
        const response = await this.getQuoteListFacetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * How the validation applies to the quote, its latest request and what it blocks.
     * Validation state of a quote
     */
    async getQuoteValidationRaw(requestParameters: GetQuoteValidationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EtatValidationDevis>> {
        if (requestParameters['devisId'] == null) {
            throw new runtime.RequiredError(
                'devisId',
                'Required parameter "devisId" was null or undefined when calling getQuoteValidation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/devis/{devisId}/validation`.replace(`{${"devisId"}}`, encodeURIComponent(String(requestParameters['devisId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EtatValidationDevisFromJSON(jsonValue));
    }

    /**
     * How the validation applies to the quote, its latest request and what it blocks.
     * Validation state of a quote
     */
    async getQuoteValidation(requestParameters: GetQuoteValidationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EtatValidationDevis> {
        const response = await this.getQuoteValidationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get quotes
     */
    async getQuotesRaw(requestParameters: GetQuotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetQuoteListResponseDto>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getQuotes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/devis/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetQuoteListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get quotes
     */
    async getQuotes(requestParameters: GetQuotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetQuoteListResponseDto> {
        const response = await this.getQuotesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Ask the validators of the tunnel to validate the quote
     */
    async requestQuoteValidationRaw(requestParameters: RequestQuoteValidationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['devisId'] == null) {
            throw new runtime.RequiredError(
                'devisId',
                'Required parameter "devisId" was null or undefined when calling requestQuoteValidation().'
            );
        }

        if (requestParameters['demanderValidationCommand'] == null) {
            throw new runtime.RequiredError(
                'demanderValidationCommand',
                'Required parameter "demanderValidationCommand" was null or undefined when calling requestQuoteValidation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/devis/{devisId}/validation/demande`.replace(`{${"devisId"}}`, encodeURIComponent(String(requestParameters['devisId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DemanderValidationCommandToJSON(requestParameters['demanderValidationCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Ask the validators of the tunnel to validate the quote
     */
    async requestQuoteValidation(requestParameters: RequestQuoteValidationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.requestQuoteValidationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send contract
     */
    async sendContractRaw(requestParameters: SendContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendContractResponseDto>> {
        if (requestParameters['sendContractCommandDto'] == null) {
            throw new runtime.RequiredError(
                'sendContractCommandDto',
                'Required parameter "sendContractCommandDto" was null or undefined when calling sendContract().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/devis/send-contrat`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendContractCommandDtoToJSON(requestParameters['sendContractCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SendContractResponseDtoFromJSON(jsonValue));
    }

    /**
     * Send contract
     */
    async sendContract(requestParameters: SendContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendContractResponseDto> {
        const response = await this.sendContractRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generates a 6-digit code, stores it on the MNCAP borrower row with a 2 min expiry, and sends it via Brevo to the borrower phone. A 60s cooldown is enforced between two sends and a maximum of 3 sends per token is allowed before a 10 min lock. 
     * Send MNCAP medical SMS code
     */
    async sendMncapMedicalSmsCodeRaw(requestParameters: SendMncapMedicalSmsCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MncapSendSmsCodeResponseDto>> {
        if (requestParameters['mncapSendSmsCodeCommand'] == null) {
            throw new runtime.RequiredError(
                'mncapSendSmsCodeCommand',
                'Required parameter "mncapSendSmsCodeCommand" was null or undefined when calling sendMncapMedicalSmsCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/devis/emprunteurs/mncap/send-sms-code`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MncapSendSmsCodeCommandToJSON(requestParameters['mncapSendSmsCodeCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MncapSendSmsCodeResponseDtoFromJSON(jsonValue));
    }

    /**
     * Generates a 6-digit code, stores it on the MNCAP borrower row with a 2 min expiry, and sends it via Brevo to the borrower phone. A 60s cooldown is enforced between two sends and a maximum of 3 sends per token is allowed before a 10 min lock. 
     * Send MNCAP medical SMS code
     */
    async sendMncapMedicalSmsCode(requestParameters: SendMncapMedicalSmsCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MncapSendSmsCodeResponseDto> {
        const response = await this.sendMncapMedicalSmsCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Trigger MNCAP process
     */
    async triggerMNCAPProcessRaw(requestParameters: TriggerMNCAPProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['borrowerId'] == null) {
            throw new runtime.RequiredError(
                'borrowerId',
                'Required parameter "borrowerId" was null or undefined when calling triggerMNCAPProcess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/devis/emprunteurs/{borrowerId}/mncap/email-bulletin-adhesion`.replace(`{${"borrowerId"}}`, encodeURIComponent(String(requestParameters['borrowerId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Trigger MNCAP process
     */
    async triggerMNCAPProcess(requestParameters: TriggerMNCAPProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.triggerMNCAPProcessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Called by the front after the borrower clicks the link received by email. Returns the current state of the token, the AERAS document URL and the masked phone number so the front can display the validation page. If the borrower has already validated, a redirectUrl is returned so the front redirects directly to the QS. 
     * Validate MNCAP medical token
     */
    async validateMncapMedicalTokenRaw(requestParameters: ValidateMncapMedicalTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MncapValidateTokenResponseDto>> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling validateMncapMedicalToken().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/devis/emprunteurs/mncap/validate-token`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MncapValidateTokenResponseDtoFromJSON(jsonValue));
    }

    /**
     * Called by the front after the borrower clicks the link received by email. Returns the current state of the token, the AERAS document URL and the masked phone number so the front can display the validation page. If the borrower has already validated, a redirectUrl is returned so the front redirects directly to the QS. 
     * Validate MNCAP medical token
     */
    async validateMncapMedicalToken(requestParameters: ValidateMncapMedicalTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MncapValidateTokenResponseDto> {
        const response = await this.validateMncapMedicalTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Verifies the 6-digit code entered by the borrower. On success calls MNCAP spe7 to generate the health questionnaire URL and returns it. Enforces a maximum of 5 attempts before invalidating the code. Expired codes (older than 2 min) are rejected. 
     * Verify MNCAP medical SMS code
     */
    async verifyMncapMedicalSmsCodeRaw(requestParameters: VerifyMncapMedicalSmsCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MncapVerifySmsCodeResponseDto>> {
        if (requestParameters['mncapVerifySmsCodeCommand'] == null) {
            throw new runtime.RequiredError(
                'mncapVerifySmsCodeCommand',
                'Required parameter "mncapVerifySmsCodeCommand" was null or undefined when calling verifyMncapMedicalSmsCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/devis/emprunteurs/mncap/verify-sms-code`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MncapVerifySmsCodeCommandToJSON(requestParameters['mncapVerifySmsCodeCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MncapVerifySmsCodeResponseDtoFromJSON(jsonValue));
    }

    /**
     * Verifies the 6-digit code entered by the borrower. On success calls MNCAP spe7 to generate the health questionnaire URL and returns it. Enforces a maximum of 5 attempts before invalidating the code. Expired codes (older than 2 min) are rejected. 
     * Verify MNCAP medical SMS code
     */
    async verifyMncapMedicalSmsCode(requestParameters: VerifyMncapMedicalSmsCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MncapVerifySmsCodeResponseDto> {
        const response = await this.verifyMncapMedicalSmsCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
